// src/components/pickers/useGuildStructure.ts
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../../lib/api';

export interface CachedChannel {
  channel_id: string;
  channel_name: string;
}

export interface CachedRole {
  role_id: string;
  role_name: string;
  color: number;
}

export function useCachedChannels(guildId: string | null) {
  return useQuery({
    queryKey: ['guild-structure-channels', guildId],
    queryFn: () => apiFetch<CachedChannel[]>(`/api/guild-structure/${guildId}/channels`),
    enabled: !!guildId,
  });
}

export function useCachedRoles(guildId: string | null) {
  return useQuery({
    queryKey: ['guild-structure-roles', guildId],
    queryFn: () => apiFetch<CachedRole[]>(`/api/guild-structure/${guildId}/roles`),
    enabled: !!guildId,
  });
}
